import React, { Component } from 'react';
import actions from '../actions';
import { connect } from 'react-redux';
import Validators from '../../../baseApp/shared/utils/Validators';
import { I18n } from 'react-redux-i18n';
import _ from '../../../baseApp/shared/utils/ObjectUtils';
import VisitsForm from "../components/VisitsForm";
import buildingActions from '../../buildings/actions'

class VisitsFormContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            alert: {
                show: false
            },
            visitFormData: {
                visitorEmail: {
                    value: undefined,
                    error: undefined,
                    required: true
                },
                visitHost: {
                    value: undefined,
                    error: undefined,
                    required: true
                },
                visitorName: {
                    value: undefined,
                    error: undefined,
                    required: false
                },
                buildingId: {
                    value: undefined,
                    error: undefined,
                    required: true
                },
                mobilePhone: {
                    value: undefined,
                    error: undefined,
                    required: false
                },
                company: {
                    value: undefined,
                    error: undefined,
                    required: false
                }
            }
        }
    }

    componentDidMount() {
        const {
            getBuildingList
        } = this.props;

        getBuildingList({
            hasCheckInConfiguration: true
        });
    }

    componentWillReceiveProps(nextProps) {
        //Handle Error, Edit and Create
         if (this.props.loadingCreateVisitRequest && !nextProps.loadingCreateVisitRequest){
            if (nextProps.visitCreated) {
                this.handleVisitCreateSuccess()
            } else {
                this.handleVisitCreateError(nextProps.error)
            }
        } else if (this.props.loadingVisit && !nextProps.loadingVisit) {
            this.handleVisitLoadingCompleted(nextProps.visitData);
        }
    };

    handleFieldChange = (id, value) => {
        this.setState({
            visitFormData: {
                ...this.state.visitFormData,
                [id]: {
                    ...this.state.visitFormData[id],
                    value: value
                }
            }
        }, () => {
            if(_.has(this.state.visitFormData[id], 'required')) {
                this.validateField(id);
            }
        })
    };

    validateField = (key) => {
        let { visitFormData } = this.state;
        let error = null;
        switch (key) {
            case "visitorEmail":
                error = !Validators.email(visitFormData[key].value) ? I18n.t('forms.errors.invalidEmail') : undefined;
                break;
            default:
                if (!_.isNilOrEmpty(visitFormData[key].error) &&
                    visitFormData[key].required &&
                    !_.isNilOrEmpty(visitFormData[key].value) ) {
                    error = undefined;
                } else if(visitFormData[key].required &&
                    _.isNilOrEmpty(visitFormData[key].value)) {
                    error = I18n.t('forms.errors.emptyRequiredField')
                }
                break;
        }
        if (error !== visitFormData[key].error) {
            visitFormData[key].error = error;
            this.setState({
                visitFormData,
            });
        }
    };

    handleOnFieldBlur = (key) => {
        this.validateField(key)
    };

    handleSubmitClick = () => {
        let { visitFormData } = this.state
        const { createVisit } = this.props
        let formHasErrors = false;

        _.forOwn(visitFormData, field => {
            if((field.required && _.isNilOrEmpty(field.value))) {
                field.error = I18n.t('forms.errors.emptyRequiredField');
                formHasErrors = true;
            } else if(!_.isNilOrEmpty(field.error)) {
                formHasErrors = true;
            } else {
                field.error = undefined;
            }
        })

        if(!formHasErrors) {
            const formDataToBeSubmitted = Object.entries(visitFormData).reduce((acc, keyValuePair) => {
                return {
                    ...acc,
                    [keyValuePair[0]]: keyValuePair[1].value,
                }
            }, {});
            const visitorName = formDataToBeSubmitted.visitorName ?
                formDataToBeSubmitted.visitorName :
                formDataToBeSubmitted.visitorEmail;
            this.setState({
                alert: {
                    show: true,
                    type: "warning",
                    title: I18n.t('visits.alerts.createCheckIn.title'),
                    html: I18n.t('visits.alerts.createCheckIn.text', { visitorName: visitorName }),
                    confirmButtonText: I18n.t('forms.submit'),
                    cancelButtonText: I18n.t('forms.cancel'),
                    onCancel: this.hideAlert,
                    onConfirm: () => createVisit(formDataToBeSubmitted)
                }
            })
        } else {
            this.setState({
                visitFormData,
            })
        }
    };

    hideAlert = () => {
        this.setState({
            alert: {
                show: false
            }
        })
    }

    handleBackClick = () => {
        this.props.resetVisitForm();
        this.hideAlert();
        this.props.history.push('/currentVisits');
    }

    handleVisitCreateSuccess = () => {
        this.setState({
            alert: {
                show: true,
                type: 'success',
                title: I18n.t('visits.alerts.checkIn.success.title'),
                html: I18n.t('visits.alerts.checkIn.success.text'),
                confirmButtonText: I18n.t('forms.ok'),
                onCancel: this.handleBackClick,
                onConfirm: this.handleBackClick
            }
        })
    }

    handleVisitCreateError = error => {
        this.setState({
            alert: {
                show: true,
                type: 'error',
                title: I18n.t('visits.alerts.checkIn.error.title'),
                html: I18n.t('visits.alerts.checkIn.error.text'),
                confirmButtonText: I18n.t('forms.ok'),
                onConfirm: this.hideAlert
            }
        })
    }

    handleVisitLoadingCompleted = visitData => {
        this.setState({
            visitFormData: {
                ...this.state.visitFormData,
                ...Object.entries(visitData).reduce(
                    (acc, keyValuePair) => ({
                        ...acc,
                        [keyValuePair[0]]: {
                            ...acc[keyValuePair[0]],
                            ...this.state.visitFormData[keyValuePair[0]],
                            value: keyValuePair[1]
                        }
                    }), {})
            }
        })
    }

    render() {
        const { visitFormData, alert } = this.state;
        const { loadingCreateRequest, buildingList } = this.props;

        return <VisitsForm
            alert={{
                ...alert,
                loading: loadingCreateRequest
            }}

            visitFormData={visitFormData}
            buildingList={buildingList}

            handleFieldChange={this.handleFieldChange}
            handleOnFieldBlur={this.handleOnFieldBlur}
            handleSubmitClick={this.handleSubmitClick}

            handleBackClick={this.handleBackClick}
        />
    }
}

const mapStateToProps = ({ 
    visitsReducer,
    buildingsReducer
}) => {
    return {
        error: visitsReducer.error,

        loadingCreateVisitRequest: visitsReducer.loadingCreateVisitRequest,
        visitCreated: visitsReducer.visitCreated,

        buildingList: buildingsReducer.buildingList
    };
};

const mapDispatchToProps = {
    createVisit: actions.createVisit,
    resetVisitForm: actions.resetVisitForm,
    getBuildingList: buildingActions.getBuildingList
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(VisitsFormContainer);
